import React from 'react'
import { Modal, Button, Form, Select, Input, theme } from 'antd'
import { UserOutlined, CloseOutlined } from '@ant-design/icons'
import { hexToRGBA } from '../../../../lib/utils'

const { Option } = Select

const AssignPatientModal = ({ isVisible, onCancel, onAssign, form }) => {
  const { token } = theme.useToken()

  return (
    <Modal
      title='Assign Patient to Bed'
      visible={isVisible}
      onCancel={onCancel}
      footer={[
        <Button
          key='cancel'
          onClick={onCancel}
          icon={<CloseOutlined style={{ color: token.colorError }} />}
          style={{
            background: hexToRGBA(token.colorError, 0.1),
            borderColor: token.colorError,
            color: token.colorError
          }}
        >
          Cancel
        </Button>,
        <Button
          key='submit'
          onClick={onAssign}
          icon={<UserOutlined style={{ color: token.colorPrimary }} />}
          style={{
            background: hexToRGBA(token.colorPrimary, 0.1),
            borderColor: token.colorPrimary,
            color: token.colorPrimary,
            fontWeight: 'bold'
          }}
        >
          Assign Patient
        </Button>
      ]}
    >
      <Form form={form} layout='vertical'>
        <Form.Item name='patientId' label='Patient' rules={[{ required: true, message: 'Please select a patient' }]}>
          <Select placeholder='Select patient' showSearch optionFilterProp='children'>
            <Option value='PT-1001'>John Smith (PT-1001)</Option>
            <Option value='PT-1023'>Emma Wilson (PT-1023)</Option>
            <Option value='PT-1045'>Michael Brown (PT-1045)</Option>
            {/* More options would be populated from patients database */}
          </Select>
        </Form.Item>

        <Form.Item
          name='admissionReason'
          label='Reason for Admission'
          rules={[{ required: true, message: 'Please enter reason for admission' }]}
        >
          <Input.TextArea rows={2} />
        </Form.Item>

        <Form.Item
          name='expectedStayDays'
          label='Expected Stay (Days)'
          rules={[{ required: true, message: 'Please enter expected stay duration' }]}
        >
          <Input type='number' min={1} />
        </Form.Item>

        <Form.Item
          name='attendingPhysician'
          label='Attending Physician'
          rules={[{ required: true, message: 'Please select attending physician' }]}
        >
          <Select placeholder='Select physician'>
            <Option value='Dr. Sarah Johnson'>Dr. Sarah Johnson</Option>
            <Option value='Dr. Robert Chen'>Dr. Robert Chen</Option>
            <Option value='Dr. Emily Taylor'>Dr. Emily Taylor</Option>
            <Option value='Dr. James Wilson'>Dr. James Wilson</Option>
            {/* More options would be populated from staff database */}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default AssignPatientModal
